import { Alert } from "antd";

function RenewalStatusAlert({ data }) {
  const getAlertConfig = (status, reason) => {
    switch (status) {
      case "not_sent":
        return {
          message:
            "This renewal hasn’t been sent yet. Review the coverage date, then send the email or share the link with the customer manually.",
          type: "warning",
        };
      case "sent":
        return {
          message:
            "This renewal is sent but pending customer action. If the status doesn’t change to ‘Complete’ after a while, please check back or resend.",
          type: "info",
        };
      case "completed":
        return {
          message:
            "This renewal has been completed by the customer. The application has been received and is available under ‘Applications → Search.’",
          type: "success",
        };
      case "cancelled":
        return {
          message: `This renewal was cancelled by an agent.${
            reason ? ` Reason: ${reason}` : ""
          }`,
          type: "error",
        };
      default:
        return null;
    }
  };

  const alertConfig = getAlertConfig(data?.status, data?.cancellation_reason);

  if (!alertConfig) return null;

  return (
    <Alert
      style={{ marginBottom: 16 }}
      message={alertConfig.message}
      type={alertConfig.type}
      showIcon
    />
  );
}
export default RenewalStatusAlert;
